export function sentenceNoise(sentence, random, probability = 0.15) {
  if (!sentence || random() >= probability) {
    return sentence;
  }

  return `${sentence} und dann`;
}
